<template>
	<div>
		<div v-for="(group, key) in groups" :key="key">
			<checkbox-type
				v-if="block.products_list_type === 1"
				v-model="products[key]"
				:title="getTitle(group)"
				:products="getProducts(group)"
				:product-key="key"
				@input="handleInput"
			/>
			<radio-type
				v-if="block.products_list_type === 2"
				v-model="products[key]"
				:title="getTitle(group)"
				:products="getProducts(group)"
				:product-key="key"
				@input="handleInput"
			/>
			<select-type
				v-if="block.products_list_type === 3"
				v-model="products[key]"
				:title="getTitle(group)"
				:products="getProducts(group)"
				:product-key="key"
				@input="handleInput"
			/>

			<div v-for="input in group.formulate_fields" :key="input.profile_slug">
				<div v-if="getProductId(products[key]) !== 0" class="form-row mb-4">
					<FormulateInput
						v-model="userData[input.profile_slug]"
						:type="input.formulate_type"
						class="col-12 col-md-6 col-lg-6"
						:name="input.profile_slug"
						:label="input.name_ru"
						:placeholder="input.placeholder"
						:validation="input.validation"
						error-behavior="live"
						:validation-messages="{
							required: 'обязательно к заполнению',
						}"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CheckboxType from '~/components/panels/formulate/products/product-types/CheckboxType.vue';
import RadioType from '~/components/panels/formulate/products/product-types/RadioType.vue';
import SelectType from '~/components/panels/formulate/products/product-types/SelectType.vue';

export default {
	name: 'ProductsGroup',
	components: {
		CheckboxType,
		RadioType,
		SelectType,
	},
	props: {
		block: {
			type: Object,
			required: true,
		},
		groups: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			products: [],
			userData: {},
		};
	},
	methods: {
		getProducts(group) {
			return group.formulate_products;
		},
		getProductId(product) {
			return parseInt(product?.products, 10);
		},
		getTitle(group) {
			if (group.show_title) return group.title;

			return null;
		},
		handleInput() {
			this.$emit('input',
				{
					products: this.products,
					userData: this.userData,
				});
		},
	},
};
</script>

<style scoped>

</style>
